/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

const {
  REACT_APP_AZURE_TENANT_ID,
  REACT_APP_AZURE_CLIENT_ID,
  REACT_APP_AZURE_BASE_URL,
  REACT_APP_AZURE_TENANT_DOMAIN,
} = process.env;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
  auth: {
    clientId: REACT_APP_AZURE_CLIENT_ID,
    authority: `https://${REACT_APP_AZURE_BASE_URL}/${REACT_APP_AZURE_TENANT_DOMAIN}/b2c_1_signin_signup`,
    redirectUri: window.location.origin,
    knownAuthorities: [REACT_APP_AZURE_BASE_URL],
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage', // You can use "sessionStorage" instead
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// export const loginRequest = {
//   scopes: ['User.Read'],
// };
export const loginRequest = (state) => ({
  // scopes: ['User.Read'],
  state: state ? JSON.stringify(state) : undefined,
});
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
